<div>
  <div class="header-style">
    <div class="h-100 d-flex">
      <mat-form-field appearance="outline" class="select">
        <mat-select data-testid="used_filter" (selectionChange)="filterChange($event.value)" [(value)]="selected" #used_filter id="used_filter"
          name="usedOnMobile_filter">
          <mat-option i18n="@@all" value="">all</mat-option>
          <mat-option i18n="@@used" value="true">Used</mat-option>
          <mat-option i18n="@@notUsed" value="false">Not Used</mat-option>
        </mat-select>
      </mat-form-field>
      @if (showSelect && selected != 'true') {
        <mat-checkbox [checked]="allSelected" (change)="setAll($event.checked)" class="all-checkbox" i18n-label="@@selectAllCheckbox"></mat-checkbox>
      }
      @if (showSelect && selected != 'true' && (userType === utils.userTypes.Manufacturer || userType === utils.userTypes.ManufacturerChild)) {
        <button i18n="@@sendEmail" data-testid="send_email_button" (click)="sendEmails()" mat-raised-button color="accent">Send email</button>
      }
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageSize]="pageSize" [pageIndex]="pageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handlePage($event)"></mat-paginator>
      @if ((userType === utils.userTypes.Manufacturer || userType === utils.userTypes.ManufacturerChild)&& selected != 'true') {
        <mat-icon data-testid="email_promotion_button" (click)="toggleSelect()" class="{{showSelect ? 'cursor add-icon header-email-icon' : 'email-color cursor add-icon header-email-icon'}}" i18n-label="@@toggleEmailSelect">email</mat-icon>
      }
      <mat-icon data-testid="add_promotion_button" (click)="openAddPromotion()" class="cursor add-icon" svgIcon="add" aria-hidden="false" i18n-label="@@addPromotionIcon"></mat-icon>
      
      @if (promotionsList.length > 0) { 
        <mat-menu #exportMenu="matMenu">
          <button mat-menu-item (click)="exportSponsorings(1)" i18n="@@exportCsv">Export as CSV</button>
          <button mat-menu-item (click)="exportSponsorings(2)" i18n="@@exportPdf">Export as PDF</button>
          <button mat-menu-item (click)="exportSponsorings(3)" i18n="@@exportExcel">Export as Excel</button>
        </mat-menu>
        <mat-icon svgIcon="export" class="cursor export-icon" aria-hidden="false" [matMenuTriggerFor]="exportMenu" i18n-label="@@exportIcon"></mat-icon>
      }

      <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
        @if (showSearch) {
          <mat-form-field class="search-field">
            <mat-label i18n="@@searchLabel">Search</mat-label>
            <input i18n-placeholder="@@searchPlaceholder" data-testid="promotions_search_input" matInput formControlName="sponsorSearch" id="sponsorSearch" placeholder="Search" name="sponsorSearch"/>
            <mat-icon data-testid="promotions_clear_button" class="cursor" matSuffix (click)="clearSearch()" i18n-label="@@clearSearchIcon">clear</mat-icon>
          </mat-form-field>
        }
      </form>
      <mat-icon data-testid="promotions_search_button" (click)="handleSearchClick()" class="cursor" svgIcon="search" aria-hidden="false" i18n-label="@@searchIcon"></mat-icon>
    </div>
  </div>
  @for (item of promotionsList; track item; let itemIndex = $index) {
    <mat-card class="{{(itemIndex % 2 === 0 ? 'lite-box-without-img mr-16 ' : 'lite-box-without-img')}}">
      <mat-card-content class="content-box">
        <div class="content">
          @if (showSelect && !item.isUsed) {
            <mat-checkbox (change)="onCheckChange(item, $event.checked)" [checked]="selectAll" class="one-checkbox" i18n-label="@@selectItemCheckbox"></mat-checkbox>
          }
          <div>
            <div class="mat-subtitle-1 mb-8">
              <span i18n="@@codeLabel" matTooltip ellipsisTooltip>Code</span>
              <span class="mx-1"> - </span>
              <span>{{ item.code }}</span>
            </div>

            <div class="mat-caption mb-8" matTooltip ellipsisTooltip>{{item.isUsed ? 'Used' : 'Not Used'}}</div>
            <div class="mat-caption mb-8" matTooltip ellipsisTooltip>{{item.expireDate}}</div>
            <div class="mat-caption mb-8 d-inline" matTooltip ellipsisTooltip>
              @if (item.isUsed) {
                <span>
                  <span i18n="@@companyUsed">Company Used:</span> {{item.companyName}}
                </span>
              }@if (!item.isUsed) {
                <span>.</span>
              }
            </div>
          </div>
        </div>
        @if ((userType === utils.userTypes.Manufacturer || userType === utils.userTypes.ManufacturerChild) && !item.isUsed) {
          <mat-icon data-testid="promotions_send_email_button" (click)="openSendEmail(item)" class="cursor email-icon" color="accent" aria-hidden="false" i18n-label="@@sendPromotionEmailIcon">email</mat-icon>
        }
      </mat-card-content>
    </mat-card>
  }
  @if (promotionsList.length === 0) {
    <img class="empty-view-img" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}" i18n-alt="@@emptyViewImageAlt">
  }
</div>
